














































































































































































import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator'
import { obterTotalDaVenda } from '@/shareds/venda-shareds'
import { formatarMoeda } from '@/shareds/formatadores'
import { Inject } from 'inversify-props'
import { FechamentoDeCaixaServiceAdapter } from '@/usecases'
import DataTablePaginado, { OnBuscarParam } from '@/components/ui/data-tables/DataTablePaginado.vue';
import { AxiosRequestConfig } from 'axios'
import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'
import { Page, VendaDoFechamento } from '@/models'
import { ObserveVisibility } from 'vue-observe-visibility'

@Component({
	components: {
		DataTablePaginado,
	},
	directives: {
		ObserveVisibility,
	},
})
export default class ListaDeVendasDoFechamento extends Vue {
	@Ref() dataTable!: DataTablePaginado
	@Prop({ type: String }) idFechamento!: string

	@Inject('FechamentoDeCaixaServiceAdapter')
	private fechamentoDeCaixaServiceAdapter!: FechamentoDeCaixaServiceAdapter

	formatarMoeda = formatarMoeda
	dateTimeToPtBrFormat = dateTimeToPtBrFormat
	obterTotalDaVenda = obterTotalDaVenda

	ordernarPor = ['situacao']
	direcaoDaOrdenacao = [false]

	carregando = false
	pagina: Page<VendaDoFechamento> | null = null
	paginaOriginal: Page<VendaDoFechamento> | null = null
	paginaAtual = 1
	filtroSelecionado: string | null = 'todas'

	headers = [
		{ text: 'ID', value: 'identificador', width: 'auto' },
		{ text: 'Valor', value: 'total', width: '128px', align: 'right' },
		{ text: '', value: 'tipoDeTransacao', width: '20px', cellClass: 'px-0', class: 'px-0' },
		{ text: '', value: '', width: '20px', cellClass: 'px-0', class: 'px-0' },
		{ text: 'Data e Hora', value: 'dataHora' },
	]

	private filtrarContent(content: VendaDoFechamento[]) {
		switch (this.filtroSelecionado) {
			case 'venda':
				return content.filter(v => v.tipoDeTransacao === 'Venda' && v.situacao === 'Concluida')
			case 'cancelada':
				return content.filter(v => v.situacao === 'Cancelada')
			case 'devolucao':
				return content.filter(v => v.temDevolucao === true && v.tipoDeTransacao === 'Venda' && v.situacao === 'Concluida')
			default:
				return content
		}
	}

	@Watch('filtroSelecionado')
	onFiltroSelecionadoChange() {
		this.paginaAtual = 1
		this.pagina = null
	}

	buscarVendasDoFechamento: OnBuscarParam = async (params: any, config?: AxiosRequestConfig) => {
		const resultado = await this.fechamentoDeCaixaServiceAdapter.getVendas(
			this.idFechamento,
			params,
			config,
		)

		this.paginaOriginal = resultado

		const filtrado = {
			...resultado,
			content: this.filtrarContent(resultado.content || []),
		}

		this.pagina = filtrado
		return filtrado
	}

	isCancelada(identificador) {
		return this.pagina?.content
			.filter(item => item.identificador === identificador)
			.some(item => item.situacao === 'Cancelada');
	}

	carregarMais() {
		if (!this.pagina || this.pagina.last || this.carregando) return
		++this.paginaAtual
	}

}
